import { useQuery } from '@tanstack/react-query'
import { doc, getDoc } from 'firebase/firestore'

import { db } from '@/firebase'

export interface CreditValue {
  credits: number
  isUnlimited: boolean
}

export type CreditValuesData = Record<string, CreditValue>

/**
 * Hook to fetch credit values from systemConfig/creditValues document
 * @returns \{ creditValues, isLoading, error \}
 */
export default function useCreditValues() {
  return useQuery<CreditValuesData>({
    queryKey: ['systemConfig', 'creditValues'],
    queryFn: async () => {
      const docRef = doc(db, 'systemConfig', 'creditValues')
      const docSnap = await getDoc(docRef)
      
      if (docSnap.exists()) {
        return docSnap.data() as CreditValuesData
      } else {
        console.warn('systemConfig/creditValues document not found')
        return {}
      }
    },
    staleTime: 60 * 60 * 1000, // 5 minutes - credit values don't change often
    cacheTime: 10 * 60 * 1000, // 10 minutes
  })
}

/**
 * Helper function to format credit information for display
 */
export function formatCredits(creditValue: string | undefined): string {
  if (!creditValue) {
    return 'Credits not available'
  }
  
  if (creditValue === 'Unlimited' || creditValue === 'unlimited') {
    return 'No AI Credit Limit'
  }
  
    return `${creditValue} AI Credits / month`
} 